import { layoutStaffSupply } from "../../models/LayoutStaffSupply";
import TrytonForm from "componentsv2/form/TrytonForm";

function StepRequest({ recId }) {
  const layoutShift = layoutStaffSupply();

  return (
    <div className="max-w-[950px] mx-auto mt-[66px] mb-20">
      <TrytonForm recordId={recId.value} layout={layoutShift} />
    </div>
  );
}

export default StepRequest;
